import { appendAuthHandoffToUrl } from '@/utils/authHandoff'

export const isIngresoHost = () => {
  if (typeof window === 'undefined') return false
  const host = window.location.hostname.toLowerCase()
  return host === 'ingreso.kameseeds.com' || host.startsWith('ingreso.')
}

export const ingresoDefaultRoute = () => '/panel/pedido-rapido'

/** URL absoluta al sitio principal (sin subdominio ingreso). */
export const buildMainSiteUrl = (path = '/') => {
  if (typeof window === 'undefined') return path
  const { protocol, hostname, port } = window.location
  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  const mainHost = hostname.startsWith('ingreso.')
    ? hostname.slice('ingreso.'.length)
    : hostname

  const portPart = port ? `:${port}` : ''
  return `${protocol}//${mainHost}${portPart}${normalizedPath}`
}

/** Ruta de panel en el dominio principal si un admin está en ingreso.*; si no, null. */
export const mainSiteUrlForAdminOnIngreso = (path = '/panel') => {
  if (typeof window === 'undefined') return null
  if (!isIngresoHost()) return null
  if (localStorage.getItem('isAdmin') !== 'true') return null
  return appendAuthHandoffToUrl(buildMainSiteUrl(path))
}

/** URL absoluta al subdominio ingreso (ej. ingreso.localhost:8080 o ingreso.kameseeds.com) */
export const buildIngresoUrl = (path = '/ingreso/tienda') => {
  if (typeof window === 'undefined') return path
  const { protocol, hostname, port } = window.location
  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  let ingresoHost
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    ingresoHost = `ingreso.${hostname}`
  } else if (hostname.startsWith('ingreso.')) {
    ingresoHost = hostname
  } else {
    const base = hostname.replace(/^www\./, '')
    ingresoHost = base.includes('kameseeds') ? 'ingreso.kameseeds.com' : `ingreso.${base}`
  }

  const portPart = port ? `:${port}` : ''
  return `${protocol}//${ingresoHost}${portPart}${normalizedPath}`
}
